module.exports = __webpack_public_path__ + "static/media/metacognition-large.ad3034a2.png";